/**
 * Picks a readable text colour (near-black or white) for a given background.
 * Used for text sitting on the brand accent, which can be light or dark
 * depending on the user's chosen palette.
 */
export const readableOn = (hexCode: string): string => {
  const hex = hexCode.replace("#", "");
  const full =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex.slice(0, 6);
  const value = parseInt(full, 16);
  const [r, g, b] = [(value >> 16) & 255, (value >> 8) & 255, value & 255].map(
    (channel) => {
      const s = channel / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    }
  );
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  // 0.179 is where white and black give equal contrast.
  return luminance > 0.179 ? "#141414" : "#ffffff";
};
